import { Link } from 'react-router-dom';
import { Package, ShoppingBag, User } from 'lucide-react';

const links = [
  { to: '/irancharsouq-admin/products', label: 'مدیریت محصولات', text: 'افزودن و به‌روزرسانی محصولات', icon: Package },
  { to: '/irancharsouq-admin/orders', label: 'مدیریت سفارشات', text: 'بررسی سفارش‌های مرتبط با محصولات', icon: ShoppingBag },
  { to: '/irancharsouq-admin/profile', label: 'پروفایل', text: 'به‌روزرسانی اطلاعات حساب', icon: User },
];

export default function IrancharsouqAdminDashboard() {
  return (
    <div>
      <div className="admin-page-header">
        <div><h1 className="admin-page-title">داشبورد مدیریت</h1><p className="admin-page-subtitle">مدیریت محصولات و سفارشات ایران چارسوق</p></div>
      </div>
      <div className="dashboard-grid">
        {links.map(({ to, label, text, icon: Icon }) => (
          <Link key={to} to={to} className="stat-card">
            <div className="stat-card-icon"><Icon size={22} /></div>
            <div><h3>{label}</h3><p>{text}</p></div>
          </Link>
        ))}
      </div>
    </div>
  );
}
